export default __webpack_public_path__ + "fonts/perfect_dos_vga_437-webfont.woff2";